exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".word-break-all {\n  word-break: break-all;\n}\n\n.well-position {\n  margin-bottom: 0;\n  overflow: hidden;\n  display: block;\n  transition: max-height 0.2s;\n}\n\n.expand-button-position {\n  position: relative;\n  top: -12px;\n}\n\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// /usr/src/app/src/app/modules/cmodules/cmodules-overview/cmodules-overview.component.css
// module id = ../../../../../src/app/modules/cmodules/cmodules-overview/cmodules-overview.component.css
// module chunks = main